import React, {useState} from 'react'
import PropTypes from 'prop-types'

MultiInput.propTypes = {
    label: PropTypes.string.isRequired,
    value_first: PropTypes.array,
    value_last: PropTypes.array,
    onChange: PropTypes.func.isRequired
}

function MultiInput(props) {
    const [inputValueFirst, setInputValueFirst] = useState('')
    const [inputValueLast, setInputValueLast] = useState('')
    const [isPaste, setIsPaste] = useState(false)

    function arrayUnique(array) {
        const a = array.concat()

        for (let i = 0; i < a.length; ++i) {
            for (let j = i + 1; j < a.length; ++j) {
                if (a[i] === a[j])
                    a.splice(j--, 1)
            }
        }

        return a
    }

    function _convertString(string, position) {
        const {regex} = props
        const newRegex = regex ? regex : /,\n|,|\s/
        const parsed = string.split(newRegex)
        let check = !!parsed && parsed.length > 0 && parsed.filter(item => item !== "")
        let combinedArray = [].concat(position === 'first' ? value_last : value_first)

        if (combinedArray.length === 0) {
            return check
        } else {
            return check.filter(x => !combinedArray.includes(x))
        }
    }

    function _checkString(string) {
        const {regex} = props
        const newRegex = regex ? new RegExp(regex.source, regex.flags + 'gi') : /,\n|,|\s/gi
        return newRegex.test(string)
    }

    function _onPasteInputLast(e) {
        const value = e.clipboardData.getData('Text')
        setIsPaste(true)
        const {onChange} = props
        const input = _convertString(value, 'last')
        const newValue = arrayUnique(value_last.concat(input))

        if (typeof onChange === 'function') {
            onChange('disallow', newValue)
        }
    }

    function _onPasteInputFirst(e) {
        const value = e.clipboardData.getData('Text')
        setIsPaste(true)
        const {onChange} = props
        const input = _convertString(value, 'first')
        const newValue = arrayUnique(value_first.concat(input))

        if (typeof onChange === 'function') {
            onChange('allow', newValue)
        }
    }

    function _handleChangeInputLast(e) {
        const {value} = e.target
        setInputValueLast(value)
        const {onChange, label, fieldAddingLast, handleSetFieldAdding} = props
        
        if(!fieldAddingLast.includes(label) && !isPaste){
            const fieldAddingLastNew = [...fieldAddingLast]
            fieldAddingLastNew.push(label)
            handleSetFieldAdding('disallow', fieldAddingLastNew)
        }
        const input = _convertString(value)
        const check = _checkString(value)

        if ((!!input && input.length > 0 && check) || (input.length === 0 && check)) {
            const newValue = arrayUnique(value_last.concat(input))

            if (typeof onChange === 'function') {
                onChange('disallow', newValue)
                setInputValueLast('')
            }

            const fieldAddingLastFinal = fieldAddingLast.filter(item => item !== label)
            handleSetFieldAdding('disallow', fieldAddingLastFinal)
        }

        if (value === '' || (!!input && input.length > 0 && check) || (input.length === 0 && check)) {
            const fieldAddingLastFinal = fieldAddingLast.filter(item => item !== label)
            handleSetFieldAdding('disallow', fieldAddingLastFinal)
        }

        if(isPaste) setInputValueLast('')
        setIsPaste(false)
    }

    function _handleChangeInputFirst(e) {
        const {value} = e.target
        setInputValueFirst(value)
        const {onChange, label, fieldAddingFirst, handleSetFieldAdding} = props
        if(!fieldAddingFirst.includes(label) && !isPaste){

            const fieldAddingFirstNew = [...fieldAddingFirst]
            fieldAddingFirstNew.push(label)
            handleSetFieldAdding('allow', fieldAddingFirstNew)
        }
        const input = _convertString(value)
        const check = _checkString(value)

        if ((!!input && input.length > 0 && check) || (input.length === 0 && check)) {
            const newValue = arrayUnique(value_first.concat(input))

            if (typeof onChange === 'function') {
                onChange('allow', newValue)
                setInputValueFirst('')
            }

            const fieldAddingFirstFinal = fieldAddingFirst.filter(item => item !== label)
            handleSetFieldAdding('allow', fieldAddingFirstFinal)
        }

        if (value === '' || (!!input && input.length > 0 && check) || (input.length === 0 && check)) {
            const fieldAddingFirstFinal = fieldAddingFirst.filter(item => item !== label)
            handleSetFieldAdding('allow', fieldAddingFirstFinal)
        }
        if(isPaste) setInputValueFirst('')
        setIsPaste(false)
    }

    function _onRemoveValueFirst(value) {
        const {onChange} = props
        const newArray = value_first.filter(item => item !== value)

        if (typeof onChange === 'function') {
            onChange('allow', newArray)
        }
    }

    function _onRemoveValueLast(value) {
        const {onChange} = props
        const newArray = value_last.filter(item => item !== value)

        if (typeof onChange === 'function') {
            onChange('disallow', newArray)
        }
    }

    const _renderPlacehoder = () => {
        return (
            <>
            Nhập {label.toLowerCase()} sau đó ấn phím cách hoặc dấu phẩy để thêm.
            </>
        )
    }

    const {label, value_first, value_last, validateFirst, validateLast, Require, regex} = props
    const inputRegex = regex || /,\n|,|\s/
    const regexSource = inputRegex.toString()

    return (
        <div className="SettingRulerInput">
            <label>{label} {!!Require && <span className='Required'>*</span>}</label>
            <div className='ListInput'>
                <label htmlFor="">Accept:</label>
                <div className="CustomSelect ant-input">
                    <div className="Selected">
                        {
                            !!value_first && value_first.length > 0 && value_first.map((item, index) => (
                                <span key={`allow-${index}`}>
                                    {item}
                                    <i
                                        className='icon-cross3 ml-1'
                                        onClick={() => _onRemoveValueFirst(item)}
                                    />
                                </span>
                            ))
                        }

                        <div className="Input">
                            <input
                                type="text"
                                value={inputValueFirst}
                                name='allow'
                                onPaste={_onPasteInputFirst}
                                onChange={_handleChangeInputFirst}
                            />
                        </div>
                    </div>
                </div>
                <div className='input-tooltip'>
                    {`Nhập ${label.toLowerCase()} sau đó ấn${regexSource.includes('\\s') ? ' phím cách hoặc':''} dấu phẩy để thêm.`}
                </div>
                {
                validateFirst && <div className="Validate">{validateFirst}</div>
                }

                <label htmlFor="">Except:</label>
                <div className="CustomSelect ant-input">
                    <div className="Selected">
                        {
                            !!value_last && value_last.length > 0 && value_last.map((item, index) => (
                                <span key={`disallow-${index}`}>
                                    {item}
                                    <i
                                        className='icon-cross3 ml-1'
                                        onClick={() => _onRemoveValueLast(item)}
                                    />
                                </span>
                            ))
                        }
                        <div className="Input">
                            <input
                                type="text"
                                value={inputValueLast}
                                name='disallow'
                                onPaste={_onPasteInputLast}
                                onChange={_handleChangeInputLast}
                            />
                        </div>
                    </div>
                </div>

                <div className='input-tooltip'>
                    {`Nhập ${label.toLowerCase()} sau đó ấn${regexSource.includes('\\s') ? ' phím cách hoặc':''} dấu phẩy để thêm.`}
                </div>
                {
                validateLast && <div className="Validate">{validateLast}</div>
                }
            </div>
        </div>
    )
}

export default MultiInput
